import Button from '@components/common/Button';
import { IconEye, IconEyeClosed } from '@components/icons';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import React, { useState } from 'react';
import { AddressText, ConnectWalletComponent, IconContainer, StyledButton } from './ConnectWalletButton.styles';

const ConnectWalletButton = () => {
  const [showAddress, setShowAddress] = useState(true);

  const toggleShowAddress = () => {
    setShowAddress(!showAddress);
  };

  return (
    <ConnectWalletComponent>
      <ConnectButton.Custom>
        {({ account, chain, openConnectModal, mounted }) => {
          const ready = mounted;
          const connected = ready && account && chain;
          return (
            <div
              {...(!ready && {
                'aria-hidden': true,
                style: {
                  opacity: 0,
                  pointerEvents: 'none',
                  userSelect: 'none',
                },
              })}
            >
              {(() => {
                if (!connected) {
                  return <Button onClick={openConnectModal}>Connect Wallet</Button>;
                }

                return (
                  <StyledButton variant="outline" noStylingHover>
                    {showAddress && <AddressText type="span">{account.displayName}</AddressText>}
                    {!showAddress && <AddressText type="span">*********</AddressText>}
                    <IconContainer onClick={toggleShowAddress}>
                      {showAddress ? <IconEye width="24" /> : <IconEyeClosed />}
                    </IconContainer>
                  </StyledButton>
                );
              })()}
            </div>
          );
        }}
      </ConnectButton.Custom>
    </ConnectWalletComponent>
  );
};

export default ConnectWalletButton;
